(function () {
  var cartWasOpenOnPointerDown = false;
  var pointerDownStartedInsideDrawer = false;
  var pointerDownStartedOnCartTrigger = false;

  function isDesktop() {
    return window.innerWidth >= 750;
  }

  function getOpenCartDialog() {
    return document.querySelector('.theme-drawer__dialog.color-custom-drawer[open]');
  }

  function isCartOpenTrigger(target) {
    return !!target.closest(
      [
        'cart-icon',
        '.header-actions__cart-icon',
        '[data-testid="cart-icon"]',
        'a[href="/cart"]',
        '[href="/cart"]',
        'button[name="cart"]',
        '[aria-label="Cart"]',
        '[aria-controls*="cart"]'
      ].join(',')
    );
  }

  function getDrawerPanel(dialog) {
    if (!dialog) return null;
    return dialog.querySelector('cart-drawer-component');
  }

  function isInsideCartDrawer(target, dialog) {
    var drawerPanel = getDrawerPanel(dialog);
    return drawerPanel && drawerPanel.contains(target);
  }

  function isCloseButton(target) {
    return !!target.closest('.theme-drawer__close-button');
  }

  function closeCartDrawer(dialog) {
    var closeButton = dialog.querySelector('.theme-drawer__close-button');

    if (closeButton) {
      closeButton.click();
    }
  }

  /*
    记录点击开始时的状态。
    这是关键：只有点击开始前购物车已经打开，才允许这次点击关闭购物车。
  */
  document.addEventListener(
    'pointerdown',
    function (event) {
      if (!isDesktop()) return;

      var dialog = getOpenCartDialog();

      cartWasOpenOnPointerDown = !!dialog;
      pointerDownStartedOnCartTrigger = isCartOpenTrigger(event.target);
      pointerDownStartedInsideDrawer = dialog ? isInsideCartDrawer(event.target, dialog) : false;
    },
    true
  );

  document.addEventListener(
    'click',
    function (event) {
      if (!isDesktop()) return;

      /*
        点击购物车图标：永远不执行关闭。
        交给原主题打开购物车。
      */
      if (pointerDownStartedOnCartTrigger || isCartOpenTrigger(event.target)) {
        return;
      }

      var dialog = getOpenCartDialog();
      if (!dialog) return;

      /*
        如果 pointerdown 时购物车还没有打开，
        说明这是打开购物车过程中的同一轮点击。
        不允许关闭。
      */
      if (!cartWasOpenOnPointerDown) {
        return;
      }

      /*
        X 按钮交给原主题关闭。
      */
      if (isCloseButton(event.target)) {
        return;
      }

      /*
        如果点击开始于购物车内部，不关闭。
        避免拖动、选择、点击数量按钮时误关。
      */
      if (pointerDownStartedInsideDrawer) {
        return;
      }

      /*
        点击结束位置在购物车内部，也不关闭。
      */
      if (isInsideCartDrawer(event.target, dialog)) {
        return;
      }

      /*
        只有点击开始前购物车已打开，
        且点击开始和结束都不在购物车内部，
        才判断为点击遮罩空白区域，执行关闭。
      */
      event.preventDefault();
      event.stopPropagation();

      closeCartDrawer(dialog);
    },
    true
  );
})();